// extracted by mini-css-extract-plugin
module.exports = {"optionWrapper":"Pai3l","heading":"_1OzPP","detailText":"_16007","imageWrapper":"_1SCXC","block":"_3uDIe","disable":"_2IzLS"};